import {
  FooterSustainability,
  FooterRange,
  FooterLogos,
  FooterLogosBoxMobile,
  FooterLogosBoxDesk,
  FooterLogosMobile,
} from "./style";
import { ImageCustom } from "../Image/index";
import { listUrl } from "../Data";

const FooterComponent = () => {
  const logos = listUrl.footer;

  return (
    <FooterSustainability>
      <FooterRange>
        <ImageCustom src={logos.logoRange} alt="Logo Arezzo&co" />
      </FooterRange>
      <FooterLogosBoxDesk>
        <FooterLogos>
          <ImageCustom src={logos.logoArezzo} alt="Logo da Arezzo" />
          <ImageCustom src={logos.logoSchutz} alt="Logo da Schutz" />
          <ImageCustom src={logos.logoAnacapri} alt="Logo da Anacapri" />
          <ImageCustom src={logos.logoAB} alt="Logo da Alexandre Birman" />
          <ImageCustom src={logos.logoVans} alt="Logo da Vans" />
          <ImageCustom src={logos.logoReserva} alt="Logo da Reserva" />
          <ImageCustom src={logos.logoZZmal} alt="Logo da ZZmal" />
          <ImageCustom src={logos.logoBaw} alt="Logo da Baw" />
        </FooterLogos>
      </FooterLogosBoxDesk>
      <FooterLogosBoxMobile>
        <FooterLogosMobile>
          <ImageCustom src={logos.logoArezzo} alt="Logo da Arezzo" />
          <ImageCustom src={logos.logoAB} alt="Logo da  Alexandre Birman" />
          <ImageCustom src={logos.logoVans} alt="Logo da Vans" />
          <ImageCustom src={logos.logoZZmal} alt="" />
        </FooterLogosMobile>
        <FooterLogosMobile className="RowSchutz">
          <ImageCustom src={logos.logoSchutz} alt="Logo da Schutz" />
          <ImageCustom src={logos.logoReserva} alt="Logo da Reserva" />
          <ImageCustom src={logos.logoBaw} alt="Logo Baw" />
          <ImageCustom src={logos.logoAnacapri} alt="Logo da Anacapri" />
        </FooterLogosMobile>
      </FooterLogosBoxMobile>
    </FooterSustainability>
  );
};

export default FooterComponent;
